// extracted by mini-css-extract-plugin
export var card = "_6n-0";
export var expandedCard = "_6n-2";
export var paginated = "_6n-1";